import { EncryptedXmlOfferSerializer, EncryptedXmlOffer } from '@/Domain/XmlOffer/Encrypter'
import { EncryptedXmlOfferJsonData } from './EncryptedXmlOfferJsonData'

export class JsonEncryptedXmlOfferSerializer implements EncryptedXmlOfferSerializer<EncryptedXmlOfferJsonData> {
  serialize (encryptedXmlOffer: EncryptedXmlOffer): EncryptedXmlOfferJsonData {
    const shamirHashes = encryptedXmlOffer.shamirHashes().map(current => {
      return {
        employeeId: current.employeeId(),
        encryptedKey: current.encryptedKey(),
        encryptedHash: current.encryptedHash()
      }
    })
    return {
      batchId: encryptedXmlOffer.batchId(),
      recordId: encryptedXmlOffer.recordId(),
      md5Hash: encryptedXmlOffer.md5Hash(),
      shamirHashes: shamirHashes
    }
  }
}
